<template>
  <div>
    <el-input :size="size" placeholder="请选择API数据源" :value="text" readonly>
      <table class="property-field-table" cellspacing="0" cellpadding="0" slot="append">
        <tr>
          <td @click="clear">&times;</td>
          <td @click="toSelect">选择API数据源</td>
        </tr>
      </table>
    </el-input>
    <api-data-source-select-dialog ref="dialog" @save="onSave" :dataType="dataType" :configColumn="configColumn" :configCondition="configCondition" :configOperation="configOperation" :endpoint="endpoint"></api-data-source-select-dialog>
  </div>
</template>

<script>
import ApiDataSourceSelectDialog from '../model/ApiDataSourceSelectDialog'

export default {
  name: 'api-data-source-select-button',
  components: {
    ApiDataSourceSelectDialog
  },
  props: {
    endpoint: { type: String, required: true },
    property: { type: Object, required: true },
    size: { type: String, required: false, default: 'mini' },
    dataType: { type: String, required: false },
    configColumn: { type: Boolean, required: false },
    configCondition: { type: Boolean, required: false },
    configOperation: { type: Boolean, required: false }
  },
  data () {
    return {
      text: ''
    }
  },
  watch: {
    'property.value': {
      handler: function (val) {
        this.text = val ? JSON.parse(val).name : ''
      },
      immediate: true
    }
  },
  methods: {
    clear () {
      this.property.value = undefined
      this.text = ''
      this.$emit('change')
    },
    toSelect () {
      this.$refs.dialog.open(this.property.value)
    },
    onSave (apiDataSource) {
      this.property.value = JSON.stringify(apiDataSource)
      this.text = apiDataSource.name
      this.$emit('change')
    }
  }
}
</script>
